import Heading from '@atlaskit/heading';
import { Inline, Flex, Stack, xcss } from '@atlaskit/primitives';
import React from 'react';

import type { HeaderActionsProps } from './PanelHeaderActions';
import PanelHeaderActions from './PanelHeaderActions';

const panelWrapper = xcss({
  padding: 'space.300',
  width: '100%',
  minWidth: '100%',
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
});

const panelHeading = xcss({
  gap: 'space.100',
});

const contentWrapper = xcss({
  justifyContent: 'flex-start',
  flex: '1 1',
  gap: 'space.300',
  overflowY: 'auto',
  overflowX: 'hidden',
});

type HeaderProps = {
  title: string;
  actions: HeaderActionsProps;
};

const PanelLayout = ({
  header,
  content,
  footer,
  testId,
}: {
  header: HeaderProps;
  content: React.ReactNode;
  footer?: React.ReactNode;
  testId?: string;
}) => {
  return (
    <Flex direction="column" gap="space.300" xcss={panelWrapper} testId={testId}>
      <Inline spread="space-between" alignBlock="center" xcss={panelHeading}>
        <Inline alignInline="start" alignBlock="center" space="space.050">
          {header.actions.backButton}
          <Heading as="h2" size="small">
            {header.title}
          </Heading>
        </Inline>
        <PanelHeaderActions {...header.actions} />
      </Inline>
      <Stack xcss={contentWrapper}>{content}</Stack>
      {footer}
    </Flex>
  );
};

export default PanelLayout;
